// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7d005e9e","453":"e0296838","732":"f776b1ab"}[chunkId] + ".chunk.js";
};